<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em"
       style="vertical-align: text-bottom;margin-bottom: 0.1em;" viewBox="0 0 512 512">
    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48"
          d="M244 400L100 256l144-144M120 256h292" />
  </svg>
</template>